function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1418",
  height: "715",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.633 692.55c86.68-32.434 184.952 4.519 284.844-7.117 102.766-12.171 101.43-38.748 240.133-56.244 87.677-11.136 339.863 70.26 429.998 74.239 108.452 4.595 163.902-33.781 269.802-17.912 63.17 9.521 125.99 19.039 189.17 28.56",
  stroke: "url(#paint0_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.704 673.804c57.548-21.623 120.727-12.467 185.716-7.49 32.316 2.487 64.994 3.885 98.051.005 102.406-11.808 102.866-38.379 239.767-54.244 27.308-3.173 69.308 2.628 117.042 11.726 101.211 19.491 227.511 52.91 297.163 59.724 5.744.568 11.13.952 16.158 1.153 88.699 3.246 142.669-21.485 217.379-21.931 16.52-.12 34.11 1.038 53.14 3.84 63.18 9.338 126.35 19.04 189.53 28.56",
  stroke: "url(#paint1_linear_119_433)",
  strokeOpacity: ".9",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.775 655.058c57.187-21.443 120.007-12.47 184.997-7.675 31.957 2.486 64.636 3.883 97.693.186 101.686-11.447 104.3-38.192 239.399-52.243 27.307-2.809 69.306 3.173 116.681 12.452 101.567 20.039 227.156 51.452 297.888 57.543 5.745.568 11.131.952 16.159.971 88.348 2.517 143.028-21.666 217.738-22.112 16.52-.12 34.12.856 53.14 3.658 63.54 9.158 126.71 18.86 189.89 28.562",
  stroke: "url(#paint2_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.917 617.384c56.828-21.262 119.29-12.837 183.562-7.863 31.598 2.303 64.276 3.7 96.973.184 100.248-10.907 107.172-37.453 238.667-48.424 28.023-2.261 69.302 4.447 115.956 14.087 102.641 21.135 226.45 48.538 299.343 53.181 5.745.385 11.131.77 16.159.789 87.273 1.238 143.393-21.847 218.813-22.472 16.88-.119 34.48.857 53.5 3.477 63.9 8.795 127.08 18.679 190.97 28.384",
  stroke: "url(#paint3_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.987 598.638c56.468-21.082 118.932-12.838 182.845-8.047 31.598 2.303 63.918 3.516 96.614.182 99.528-10.546 108.606-36.902 238.3-46.423 28.382-2.078 69.299 5.175 115.594 14.995 102.998 21.683 226.096 47.081 300.068 51 5.746.385 11.132.588 16.161.607 86.911.691 143.751-21.845 219.171-22.653 16.88-.119 34.48.858 53.51 3.477 64.25 8.615 127.43 18.681 191.32 28.386",
  stroke: "url(#paint4_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.128 561.146c56.109-20.901 117.856-13.207 181.409-8.417 31.239 2.302 63.56 3.516 95.897.179 98.089-9.822 111.835-35.979 237.566-42.421 28.739-1.53 69.294 6.449 114.87 16.631 103.712 22.777 225.028 44.346 301.88 46.82 5.745.203 11.132.406 16.16.425 86.2-.586 144.47-22.206 220.25-23.013 17.24-.117 34.84.677 53.87 3.297 64.61 8.434 127.79 18.5 192.4 28.207",
  stroke: "url(#paint5_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.199 542.4c55.749-20.902 117.496-13.208 180.692-8.602 31.238 2.302 63.2 3.333 95.537.178 97.369-9.643 113.629-35.426 237.2-40.421 29.096-1.164 69.291 7.177 114.507 17.358 104.069 23.324 224.675 42.889 302.606 44.639 5.746.204 11.134.224 16.162.243 85.487-1.134 144.827-22.205 220.617-23.193 17.24-.3 34.83.677 53.86 3.114 64.62 8.252 128.15 18.502 192.76 28.209",
  stroke: "url(#paint6_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.27 523.472c55.39-20.722 116.779-13.393 179.975-8.786 30.879 2.3 62.841 3.33 95.177.176 96.65-9.282 115.423-34.873 236.474-38.421 29.455-.8 69.289 7.905 114.146 18.084 104.785 24.055 224.321 41.432 303.333 42.457 5.747.022 11.133.224 16.162.061 85.133-1.681 145.183-22.385 220.973-23.374 17.24-.299 35.2.679 54.22 2.935 64.98 8.071 128.51 18.32 193.13 28.21",
  stroke: "url(#paint7_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.341 504.726c55.03-20.541 116.42-13.394 179.257-8.971 30.88 2.118 62.482 3.147 94.818.175 95.93-8.921 116.856-34.14 236.107-36.421 29.813-.616 69.287 8.633 113.784 18.993 105.142 24.603 223.607 40.155 304.059 40.276 5.747.022 11.134.042 16.163-.121 84.771-2.228 145.181-22.385 221.331-23.554 17.24-.299 35.2.678 54.22 2.934 64.98 7.889 128.52 18.321 193.85 28.213",
  stroke: "url(#paint8_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.412 485.98c54.67-20.543 116.061-13.577 178.539-9.156 30.88 2.119 62.482 3.148 94.458.174 95.211-8.559 118.65-33.406 235.741-34.42 30.171-.251 69.285 9.179 113.422 19.719 105.499 25.15 223.253 38.88 304.786 38.095 5.746.022 11.133.042 16.162-.121 84.41-2.776 145.55-22.566 222.05-23.734 17.6-.298 35.56.498 54.23 2.752 65.33 7.709 128.87 18.14 194.2 28.033",
  stroke: "url(#paint9_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.482 467.233c54.67-20.36 115.703-13.76 177.821-9.34 30.521 2.117 62.124 3.146 94.1.355 94.851-8.379 120.802-32.67 235.374-32.42 30.529.115 69.281 9.907 113.059 20.628 105.856 25.697 222.899 37.422 305.512 35.914 5.747-.161 11.134-.14 16.163-.303 83.699-3.325 145.909-22.747 222.409-23.915 17.6-.298 35.56.498 54.59 2.754 65.69 7.527 129.23 18.141 194.56 28.033",
  stroke: "url(#paint10_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.553 448.487c54.31-20.362 114.984-13.763 177.103-9.525 30.521 2.117 61.765 2.963 93.741.353 94.131-8.017 122.594-31.752 235.007-30.419 30.887.299 69.638 10.637 112.697 21.355 106.213 26.427 222.185 36.146 306.238 33.733a3690.64 3690.64 0 0016.164-.485c83.337-4.055 146.267-22.746 222.777-24.096 17.6-.297 35.55.498 54.58 2.572 65.7 7.346 129.23 18.141 195.28 28.036",
  stroke: "url(#paint11_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.624 429.559c53.95-20.181 114.626-13.946 176.386-9.709 30.162 2.115 61.765 2.962 93.381.352 93.412-7.657 124.388-31.018 234.641-28.419 31.245.664 69.635 11.365 112.334 22.264 106.57 26.974 221.832 34.87 306.966 31.551 5.747-.161 11.135-.322 16.165-.667 82.983-4.602 146.623-22.926 223.133-24.276 17.6-.298 35.91.499 54.94 2.573 66.06 7.165 129.59 17.96 195.64 28.037",
  stroke: "url(#paint12_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.695 410.813c53.59-20 114.268-14.129 175.668-9.894 30.162 2.116 61.407 2.779 93.022.35 92.692-7.477 126.18-30.101 234.274-26.417 31.602 1.029 69.633 11.91 111.973 22.99 107.286 27.522 221.117 33.593 307.692 29.37 5.748-.343 11.136-.505 16.164-.668 82.632-5.148 146.982-22.924 223.852-24.455 17.96-.296 35.91.5 54.94 2.391 66.06 6.983 129.95 17.962 196 27.857",
  stroke: "url(#paint13_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.765 392.067c53.232-20.002 113.55-14.132 174.951-10.079 30.163 1.934 61.047 2.778 92.662.349 91.973-7.115 127.973-29.184 233.908-24.417 31.96 1.395 69.63 12.639 111.969 23.718 107.643 28.252 220.764 32.137 308.778 27.19 5.748-.342 11.136-.504 16.166-.849 82.271-5.696 146.981-23.107 224.211-24.636 17.96-.296 36.27.319 54.94 2.391 66.42 6.803 130.31 17.782 196.72 27.86",
  stroke: "url(#paint14_linear_119_433)",
  strokeOpacity: ".9",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.836 373.321c53.23-19.82 113.19-14.316 174.233-10.264 29.803 1.933 60.689 2.777 92.304.348 91.253-6.754 129.764-28.086 233.541-22.599 32.318 1.76 69.627 13.367 111.607 24.627 107.999 28.8 220.409 30.861 309.504 25.009 5.748-.342 11.137-.686 16.526-1.03 81.549-6.245 147.349-23.287 224.569-24.816 17.96-.297 36.27.318 55.3 2.21 66.42 6.62 130.31 17.781 197.08 27.861",
  stroke: "url(#paint15_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.907 354.575c52.871-19.821 112.832-14.499 173.515-10.449 29.803 1.933 60.689 2.595 91.945.347 90.534-6.575 131.555-27.169 233.174-20.598 32.676 2.125 69.624 14.095 111.245 25.354 108.356 29.346 219.696 29.766 310.231 22.827 5.748-.343 11.136-.686 16.526-1.212 81.197-6.792 147.707-23.286 224.927-24.997 17.96-.478 36.28.319 55.31 2.21 66.78 6.44 130.66 17.601 197.43 27.863",
  stroke: "url(#paint16_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.978 335.647c52.512-19.64 112.473-14.5 172.798-10.633 29.444 1.931 60.33 2.593 91.585.345 89.814-6.214 133.707-26.069 232.449-18.599 33.392 2.492 69.622 14.823 110.883 26.263 108.713 30.076 219.34 28.49 310.957 20.645 5.748-.524 11.137-.867 16.526-1.211 80.844-7.34 148.064-23.467 225.654-25.177 18.31-.477 36.63.32 55.66 2.03 67.14 6.441 131.03 17.602 198.15 27.683",
  stroke: "url(#paint17_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.049 316.901c52.152-19.46 111.755-14.685 172.08-10.818 29.444 1.931 59.971 2.41 91.226.344 89.094-5.853 135.499-24.97 232.082-16.598 33.751 2.857 69.619 15.55 110.521 26.989 109.07 30.623 218.986 27.215 311.683 18.464 5.749-.524 11.138-.868 16.527-1.394 80.482-7.705 148.422-23.647 226.012-25.356 18.32-.477 36.63.138 55.66 2.029 67.14 6.259 131.03 17.602 198.51 27.685",
  stroke: "url(#paint18_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.12 298.155c51.792-19.461 111.396-14.868 171.362-11.003 29.085 1.93 59.971 2.41 90.866.343 88.376-5.673 137.291-23.871 231.716-14.597 34.107 3.404 69.617 16.278 110.159 27.715 109.426 31.353 218.273 25.939 312.41 16.283 5.749-.524 11.138-1.05 16.527-1.575 79.77-8.254 148.78-23.646 226.37-25.538 18.32-.477 36.99.139 55.66 1.848 67.5 6.078 131.39 17.421 198.88 27.685",
  stroke: "url(#paint19_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.261 260.481c51.433-19.281 110.32-15.055 169.927-11.372 29.086 1.747 59.254 2.225 90.149.522 86.936-4.951 140.873-21.492 230.982-10.597 34.823 4.136 69.611 17.553 109.434 29.351 110.14 32.63 217.563 23.57 313.863 11.921 5.39-.708 11.139-1.232 16.529-1.94 79.055-9.348 149.145-23.826 227.445-25.897 18.68-.476 37.35.14 56.03 1.667 67.86 5.716 132.1 17.242 199.95 27.507",
  stroke: "url(#paint20_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.332 241.735c51.073-19.1 109.961-15.056 169.21-11.557 28.726 1.746 58.894 2.224 89.788.52 86.217-4.771 142.664-20.211 230.615-8.595 35.181 4.683 69.61 18.281 109.072 30.259 110.497 33.359 217.209 22.477 314.59 9.74 5.39-.708 11.139-1.232 16.529-1.94 78.694-9.896 149.504-24.007 227.804-26.078 18.68-.476 37.36-.041 56.39 1.486 68.22 5.535 132.1 17.242 200.31 27.51",
  stroke: "url(#paint21_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.473 204.243c50.354-18.921 109.244-15.423 167.775-11.926a806.479 806.479 0 0089.069.517c85.137-4.047 145.888-17.832 229.882-4.594 35.536 5.594 69.604 19.737 108.348 31.895 111.21 34.636 216.14 20.107 316.401 5.56 5.391-.889 11.141-1.596 16.531-2.304 77.981-10.808 150.221-24.186 228.891-26.438 19.03-.474 37.71-.04 56.38 1.305 68.58 5.172 132.82 17.062 201.39 27.513",
  stroke: "url(#paint22_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.544 185.497c50.353-18.739 108.525-15.426 167.056-12.111 28.368 1.745 58.178 1.857 88.712.516 84.418-3.868 147.678-16.552 229.515-2.593 35.893 6.141 69.601 20.464 107.986 32.621 111.567 35.183 215.784 19.013 317.127 3.379 5.391-.89 11.141-1.596 16.531-2.486 77.259-11.357 150.579-24.367 229.249-26.619 19.04-.474 37.71-.039 56.74 1.306 68.58 4.991 132.83 17.063 201.75 27.333",
  stroke: "url(#paint23_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.615 166.569c49.994-18.74 108.167-15.609 166.339-12.296a892.452 892.452 0 0088.353.515c83.698-3.507 149.468-15.089 229.148-.593 36.25 6.689 69.239 21.191 107.623 33.348 111.924 35.913 215.431 17.738 317.855 1.198 5.391-.89 11.14-1.778 16.53-2.486 76.907-11.904 150.587-24.367 229.607-26.799 19.04-.657 38.07-.221 56.74 1.123 68.94 4.81 133.19 16.882 202.47 27.336",
  stroke: "url(#paint24_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.756 129.076c49.275-18.378 107.091-15.794 164.905-12.664 28.008 1.561 57.459 1.672 87.633.512 82.26-2.966 152.332-12.531 228.056 3.407 36.606 7.6 69.233 22.647 106.899 34.983 112.277 37.37 214.72 15.552 319.307-3.165 5.392-1.072 11.142-1.96 16.533-2.85 76.191-12.817 151.301-24.728 230.681-27.159 19.4-.655 38.08-.22 57.11.943 69.3 4.265 133.9 16.703 203.18 27.338",
  stroke: "url(#paint25_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.827 110.33c49.275-18.378 106.732-15.978 164.187-12.85 27.649 1.56 57.1 1.672 87.273.693 81.54-2.604 153.765-11.25 227.69 5.226 36.963 8.33 69.23 23.376 106.536 35.892 112.635 37.917 214.366 14.458 320.035-5.346 5.391-1.072 11.141-1.96 16.532-3.032 75.83-13.364 151.66-24.727 231.05-27.34 19.39-.655 38.43-.219 57.1.943 69.66 4.267 133.9 16.703 203.54 27.158",
  stroke: "url(#paint26_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.898 91.584C51.812 73.386 109.27 75.423 166.366 78.55c27.65 1.56 57.102 1.489 86.915.691 80.821-2.425 155.195-9.79 227.323 7.227 37.319 8.876 69.228 24.103 106.174 36.618 112.991 38.647 214.011 13.365 320.761-7.527a526.653 526.653 0 0116.533-3.032c75.477-13.912 152.018-24.908 231.408-27.52 19.39-.656 38.43-.402 57.46.762 69.66 4.084 134.26 16.522 204.26 27.16",
  stroke: "url(#paint27_linear_119_433)",
  strokeOpacity: ".8",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.969 72.656c48.555-18.2 106.014-16.163 162.751-13.22 27.649 1.561 56.742 1.489 86.556.69 80.102-2.245 156.627-8.509 226.956 9.228 37.317 9.423 69.225 24.831 105.812 37.527 113.347 39.376 214.015 12.273 321.487-9.709 5.392-1.071 10.783-2.143 16.534-3.213 75.119-14.278 152.375-24.907 231.765-27.702 19.76-.653 38.79-.4 57.46.58 70.03 3.905 134.63 16.524 204.62 27.162",
  stroke: "url(#paint28_linear_119_433)",
  strokeOpacity: ".9",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.04 53.91c48.195-18.019 105.296-16.348 162.033-13.404 27.291 1.377 56.384 1.305 86.196.69 79.383-1.886 158.059-7.05 226.59 11.227 37.316 9.969 69.222 25.56 105.45 38.254 113.344 40.104 213.66 11.179 322.214-11.89 5.391-1.072 10.784-2.326 16.534-3.396 74.762-14.825 152.383-25.089 232.483-27.88 19.76-.654 38.79-.4 57.46.58 70.39 3.723 134.63 16.523 204.98 27.162",
  stroke: "url(#paint29_linear_119_433)",
  strokeOpacity: ".9",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.11 35.164c47.836-17.838 104.938-16.35 161.316-13.589 27.291 1.377 56.024 1.304 85.837.688 78.662-1.524 159.131-5.77 226.223 13.228 37.672 10.698 69.22 26.288 105.088 38.981 113.701 40.833 213.305 10.086 323.3-14.07 5.392-1.254 10.784-2.326 16.535-3.578 74.404-15.19 152.741-25.27 232.841-28.061 19.76-.654 38.79-.4 57.83.4 70.38 3.54 134.98 16.342 205.69 26.983",
  stroke: "url(#paint30_linear_119_433)",
  strokeOpacity: ".9",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.18 16.418C51.018-1.42 107.76-.114 163.78 2.645 262.53 7.749 385.065-8.534 474.754 18.559c37.67 11.244 69.216 27.015 104.725 39.889C693.536 100.01 792.43 67.44 903.506 42.196c78.724-17.903 163.524-28.686 249.734-31.82 94.84-3.464 174.51 13.762 263.89 27.385",
  stroke: "url(#paint31_linear_119_433)",
  strokeOpacity: ".9",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_119_433",
  x1: "707.379",
  y1: "712.233",
  x2: "707.697",
  y2: "627.798",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_119_433",
  x1: "707.45",
  y1: "693.449",
  x2: "707.761",
  y2: "611.027",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_119_433",
  x1: "707.521",
  y1: "674.664",
  x2: "707.824",
  y2: "594.232",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#7D7D7D",
  stopOpacity: ".89"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_119_433",
  x1: "707.662",
  y1: "637.096",
  x2: "707.951",
  y2: "560.6",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_119_433",
  x1: "707.733",
  y1: "618.311",
  x2: "708.014",
  y2: "543.761",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_119_433",
  x1: "707.874",
  y1: "580.743",
  x2: "708.141",
  y2: "510.037",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_119_433",
  x1: "707.945",
  y1: "561.959",
  x2: "708.205",
  y2: "493.153",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_119_433",
  x1: "708.016",
  y1: "543.174",
  x2: "708.268",
  y2: "476.255",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_119_433",
  x1: "708.087",
  y1: "524.39",
  x2: "708.332",
  y2: "459.342",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_119_433",
  x1: "708.157",
  y1: "505.606",
  x2: "708.396",
  y2: "442.414",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_119_433",
  x1: "708.228",
  y1: "486.821",
  x2: "708.46",
  y2: "425.471",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_119_433",
  x1: "708.299",
  y1: "468.037",
  x2: "708.523",
  y2: "408.49",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_119_433",
  x1: "708.37",
  y1: "449.253",
  x2: "708.588",
  y2: "391.432",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_119_433",
  x1: "708.441",
  y1: "430.468",
  x2: "708.652",
  y2: "374.307",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_119_433",
  x1: "708.511",
  y1: "411.684",
  x2: "708.717",
  y2: "357.122",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_119_433",
  x1: "708.58",
  y1: "393.52",
  x2: "708.782",
  y2: "339.884",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#747474"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_119_433",
  x1: "708.645",
  y1: "376.236",
  x2: "708.847",
  y2: "322.599",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_119_433",
  x1: "708.71",
  y1: "359.104",
  x2: "708.912",
  y2: "305.27",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_119_433",
  x1: "708.773",
  y1: "342.105",
  x2: "708.978",
  y2: "287.899",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_119_433",
  x1: "708.837",
  y1: "325.227",
  x2: "709.043",
  y2: "270.487",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_119_433",
  x1: "708.963",
  y1: "291.765",
  x2: "709.175",
  y2: "235.544",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_119_433",
  x1: "709.026",
  y1: "275.157",
  x2: "709.241",
  y2: "218.011",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_119_433",
  x1: "709.15",
  y1: "242.134",
  x2: "709.374",
  y2: "182.81",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_119_433",
  x1: "709.212",
  y1: "225.702",
  x2: "709.44",
  y2: "165.136",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_119_433",
  x1: "709.274",
  y1: "209.315",
  x2: "709.507",
  y2: "147.408",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_119_433",
  x1: "709.397",
  y1: "176.654",
  x2: "709.641",
  y2: "111.768",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_119_433",
  x1: "709.458",
  y1: "160.371",
  x2: "709.709",
  y2: "93.844",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear_119_433",
  x1: "709.519",
  y1: "144.116",
  x2: "709.777",
  y2: "75.814",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear_119_433",
  x1: "709.581",
  y1: "127.885",
  x2: "709.845",
  y2: "57.732",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_119_433",
  x1: "709.642",
  y1: "111.676",
  x2: "709.914",
  y2: "39.56",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint30_linear_119_433",
  x1: "709.703",
  y1: "95.525",
  x2: "709.983",
  y2: "21.21",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint31_linear_119_433",
  x1: "709.764",
  y1: "79.315",
  x2: "710.054",
  y2: "2.339",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})))));